import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "matching-tpay-wrapper"
}
const _hoisted_2 = { class: "matching-tpay" }
const _hoisted_3 = { class: "mt-steps" }
const _hoisted_4 = { class: "mt-step__circle" }
const _hoisted_5 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_6 = { class: "mt-step__label" }
const _hoisted_7 = {
  key: 0,
  class: "mt-bar"
}
const _hoisted_8 = { class: "mt-amount" }
const _hoisted_9 = { class: "mt-timer" }
const _hoisted_10 = {
  key: 1,
  class: "mt-bar"
}
const _hoisted_11 = { class: "mt-timer" }
const _hoisted_12 = { class: "mt-bank" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "mt-bank__text" }
const _hoisted_15 = { class: "mt-field" }
const _hoisted_16 = { class: "form-field" }
const _hoisted_17 = {
  key: 0,
  class: "mt-tpay-bleed"
}
const _hoisted_18 = {
  key: 1,
  class: "mt-hint"
}
const _hoisted_19 = {
  key: 2,
  class: "mt-hint"
}
const _hoisted_20 = { class: "mt-field" }
const _hoisted_21 = { class: "form-field" }
const _hoisted_22 = { class: "email-field" }
const _hoisted_23 = { class: "mt-tabs" }
const _hoisted_24 = { class: "mt-instructions" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "mt-instructions__icon" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 4,
  class: "mt-status"
}
const _hoisted_30 = { class: "result" }
const _hoisted_31 = {
  key: 0,
  class: "result__visual"
}
const _hoisted_32 = { class: "result__text" }
const _hoisted_33 = {
  key: 1,
  class: "result__visual"
}
const _hoisted_34 = { class: "result__text" }
const _hoisted_35 = {
  key: 2,
  class: "result__visual"
}
const _hoisted_36 = { class: "result__text" }
const _hoisted_37 = {
  key: 5,
  class: "mt-actions"
}
const _hoisted_38 = {
  key: 6,
  class: "mt-actions"
}
const _hoisted_39 = {
  key: 7,
  class: "mt-actions"
}
const _hoisted_40 = ["href"]

import DealDTO from "@/models/DealDTO";
import InvoiceStateDTO from "@/models/InvoiceStateDTO";
import {numberFormatter} from "@/service/NumberFormatter";
import {paymentMethodsHelper} from "@/service/PaymentMethodsHelper";
import TPayButton from "@/components/PayButtons/TPayButton.vue";
import {copy, formatCancelTime, openDeeplink, state as copyState} from "@/service/helper";
import {FlowType} from "@/enum/FlowType";
import {InvoiceStatus} from "@/enum/InvoiceStatus";
import {DealStatus} from "@/enum/DealStatus";
import {computed, ref} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TPayMatching',
  props: {
    confirmTransfer: { type: Function },
    cancelDeal: { type: Function },
    waitingForRequisites: { type: Boolean },
    currentDeal: {},
    invoice: {}
  },
  setup(__props: any) {


const props = __props

const step = ref<1 | 2>(1)
const os = ref<'android' | 'ios'>('android')

const showReceiptStep = computed(() => props.invoice.flowData?.options?.emailCheckConfirmation === true)
const finalStepIndex = computed(() => showReceiptStep.value ? 3 : 2)

const steps = computed(() => {
  const list = [{n: 1, label: 'Оплата'}]
  if (showReceiptStep.value) {
    list.push({n: 2, label: 'Квитанция'})
  }
  list.push({n: finalStepIndex.value, label: 'Проверка'})
  return list
})

const phase = computed<'pay' | 'receipt' | 'verify'>(() => {
  if (props.currentDeal.status !== DealStatus.TRANSFER_WAITING) {
    return 'verify'
  }
  return step.value === 2 && showReceiptStep.value ? 'receipt' : 'pay'
})

const activeStep = computed(() => {
  if (phase.value === 'verify') {
    return finalStepIndex.value
  }
  return phase.value === 'receipt' ? 2 : 1
})

const stepState = (n: number): 'done' | 'active' | 'upcoming' => {
  if (n < activeStep.value) {
    return 'done'
  }
  return n === activeStep.value ? 'active' : 'upcoming'
}

const stepClass = (n: number) => {
  const s = stepState(n)
  return {'is-active': s === 'active', 'is-done': s === 'done'}
}

const goToReceipt = () => {
  if (showReceiptStep.value) {
    step.value = 2
    return
  }
  props.confirmTransfer()
}


return (_ctx: any,_cache: any) => {
  return (_ctx.currentDeal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (s) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["mt-step", stepClass(s.n)]),
                key: s.n
              }, [
                _createElementVNode("div", _hoisted_4, [
                  (stepState(s.n) === 'done')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[10] || (_cache[10] = [
                        _createElementVNode("path", {
                          d: "M5 13L9 17L19 7",
                          stroke: "white",
                          "stroke-width": "3",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, null, -1)
                      ])))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(s.n), 1)
                      ], 64))
                ]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(s.label), 1)
              ], 2))
            }), 128))
          ]),
          (phase.value === 'pay')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_unref(numberFormatter).formatMoney(Number(_ctx.invoice.sum.amount), _ctx.invoice.sum.currency)) + " ", 1),
                  _createElementVNode("a", {
                    class: "copy-link",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(copy)(_ctx.$el, _ctx.invoice.sum.amount)), ["prevent"]))
                  })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[11] || (_cache[11] = _createElementVNode("svg", {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none"
                  }, [
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "12",
                      r: "9",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }),
                    _createElementVNode("path", {
                      d: "M12 7V12L15.5 14",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(formatCancelTime)(_ctx.currentDeal)), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (phase.value === 'receipt')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "button",
                  class: "mt-back",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (step.value = 1), ["prevent"]))
                }, _cache[12] || (_cache[12] = [
                  _createElementVNode("svg", {
                    width: "18",
                    height: "18",
                    viewBox: "0 0 24 24",
                    fill: "none"
                  }, [
                    _createElementVNode("path", {
                      d: "M15 6L9 12L15 18",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1),
                  _createTextVNode(" Реквизиты ")
                ])),
                _createElementVNode("div", _hoisted_11, [
                  _cache[13] || (_cache[13] = _createElementVNode("svg", {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none"
                  }, [
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "12",
                      r: "9",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }),
                    _createElementVNode("path", {
                      d: "M12 7V12L15.5 14",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(formatCancelTime)(_ctx.currentDeal)), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (phase.value === 'pay')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("img", {
                    class: "mt-bank__icon",
                    src: _unref(paymentMethodsHelper).getLogo(_ctx.currentDeal.paymentMethod)
                  }, null, 8, _hoisted_13),
                  _createElementVNode("div", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_ctx.$t(`methods.${_ctx.currentDeal.paymentMethod}`)), 1),
                    (_ctx.currentDeal.requisites.holder)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" · " + _toDisplayString(_ctx.currentDeal.requisites.holder), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", null, "Номер телефона получателя", -1)),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.currentDeal.requisites.requisites), 1),
                    _createElementVNode("a", {
                      class: "copy-link",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(copy)(_ctx.$el, _ctx.currentDeal.requisites.requisites)), ["prevent"]))
                    })
                  ])
                ]),
                (_ctx.invoice.flow === _unref(FlowType).TPAY && _ctx.invoice.flowData?.deeplinks)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(TPayButton, {
                        "onBtn:click": _cache[3] || (_cache[3] = ($event: any) => (_unref(openDeeplink)(_ctx.invoice.flowData.deeplinks)))
                      })
                    ]))
                  : _createCommentVNode("", true),
                (showReceiptStep.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Дальше нужно будет отправить квитанцию — без неё платёж не зачислится"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t('invoice.transfer-disclaimer')), 1))
              ], 64))
            : _createCommentVNode("", true),
          (phase.value === 'receipt')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _cache[19] || (_cache[19] = _createElementVNode("h1", { class: "mt-title" }, "Отправьте квитанцию из банка", -1)),
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mt-subtitle" }, "Без неё платёж не зачислится", -1)),
                _createElementVNode("div", _hoisted_20, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", null, "Почта для квитанции", -1)),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.currentDeal.matchingEmail), 1),
                    _createElementVNode("a", {
                      class: "copy-link",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_unref(copy)(_ctx.$el, _ctx.currentDeal.matchingEmail)), ["prevent"]))
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass({'is-active': os.value === 'android'}),
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (os.value = 'android'), ["prevent"]))
                  }, "Android", 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass({'is-active': os.value === 'ios'}),
                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (os.value = 'ios'), ["prevent"]))
                  }, "iPhone", 2)
                ]),
                _createElementVNode("ul", _hoisted_24, [
                  _cache[17] || (_cache[17] = _createElementVNode("li", null, [
                    _createElementVNode("span", { class: "mt-instructions__icon" }, [
                      _createElementVNode("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 24 24",
                        fill: "none"
                      }, [
                        _createElementVNode("path", {
                          d: "M12 5L11.2929 4.29289L12 3.58579L12.7071 4.29289L12 5ZM13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14L13 14ZM6.29289 9.29289L11.2929 4.29289L12.7071 5.70711L7.70711 10.7071L6.29289 9.29289ZM12.7071 4.29289L17.7071 9.29289L16.2929 10.7071L11.2929 5.70711L12.7071 4.29289ZM13 5L13 14L11 14L11 5L13 5Z",
                          fill: "#111214"
                        }),
                        _createElementVNode("path", {
                          d: "M5 16L5 17C5 18.1046 5.89543 19 7 19L17 19C18.1046 19 19 18.1046 19 17V16",
                          stroke: "#111214",
                          "stroke-width": "2"
                        })
                      ])
                    ]),
                    _createElementVNode("span", null, "В квитанции нажмите «Поделиться»")
                  ], -1)),
                  (os.value === 'android')
                    ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                        _createElementVNode("span", _hoisted_26, [
                          _createElementVNode("img", {
                            src: _unref(paymentMethodsHelper).getLogo(_ctx.currentDeal.paymentMethod)
                          }, null, 8, _hoisted_27)
                        ]),
                        _createElementVNode("span", null, "Выберите «" + _toDisplayString(_ctx.$t(`methods.${_ctx.currentDeal.paymentMethod}`)) + ", отправить почтой»", 1)
                      ]))
                    : (_openBlock(), _createElementBlock("li", _hoisted_28, _cache[16] || (_cache[16] = [
                        _createElementVNode("span", { class: "mt-instructions__icon" }, [
                          _createElementVNode("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none"
                          }, [
                            _createElementVNode("path", {
                              d: "M21 8L17.4392 9.97822C15.454 11.0811 14.4614 11.6326 13.4102 11.8488C12.4798 12.0401 11.5202 12.0401 10.5898 11.8488C9.53864 11.6326 8.54603 11.0811 6.5608 9.97822L3 8M6.2 19H17.8C18.9201 19 19.4802 19 19.908 18.782C20.2843 18.5903 20.5903 18.2843 20.782 17.908C21 17.4802 21 16.9201 21 15.8V8.2C21 7.0799 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.51984 19 5.07989 19 6.2 19Z",
                              stroke: "#111214",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            })
                          ])
                        ], -1),
                        _createElementVNode("span", null, "Выберите «Отправить по почте»", -1)
                      ]))),
                  _cache[18] || (_cache[18] = _createStaticVNode("<li><span class=\"mt-instructions__icon\"><svg width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\"><rect x=\"6\" y=\"4\" width=\"12\" height=\"17\" rx=\"2\" stroke=\"#111214\" stroke-width=\"1.6\"></rect><path d=\"M9 4V3.5C9 2.67157 9.67157 2 10.5 2H13.5C14.3284 2 15 2.67157 15 3.5V4\" stroke=\"#111214\" stroke-width=\"1.6\"></path><path d=\"M9 11H15M9 15H13\" stroke=\"#111214\" stroke-width=\"1.6\" stroke-linecap=\"round\"></path></svg></span><span>Вставьте почту и отправьте</span></li>", 1))
                ])
              ], 64))
            : _createCommentVNode("", true),
          (phase.value === 'verify')
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  (_ctx.currentDeal.status === _unref(DealStatus).CANCELED)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "result__fail" }, [
                          _createElementVNode("svg", {
                            width: "33",
                            height: "32",
                            viewBox: "0 0 33 32",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              d: "M4.87493 1.06214C4.43063 0.648142 3.84299 0.422757 3.2358 0.433471C2.62861 0.444184 2.04928 0.690158 1.61986 1.11957C1.19045 1.54899 0.944472 2.12832 0.933758 2.73551C0.923045 3.3427 1.14843 3.93035 1.56243 4.37464L13.1874 15.9996L1.56243 27.6246C1.33216 27.8392 1.14746 28.098 1.01936 28.3855C0.891264 28.673 0.822384 28.9833 0.816832 29.298C0.81128 29.6127 0.869168 29.9253 0.987047 30.2171C1.10492 30.509 1.28038 30.7741 1.50294 30.9966C1.72549 31.2192 1.9906 31.3946 2.28244 31.5125C2.57428 31.6304 2.88687 31.6883 3.20156 31.6827C3.51626 31.6772 3.82661 31.6083 4.11411 31.4802C4.40161 31.3521 4.66036 31.1674 4.87493 30.9371L16.4999 19.3121L28.1249 30.9371C28.3395 31.1674 28.5983 31.3521 28.8857 31.4802C29.1732 31.6083 29.4836 31.6772 29.7983 31.6827C30.113 31.6883 30.4256 31.6304 30.7174 31.5125C31.0093 31.3946 31.2744 31.2192 31.4969 30.9966C31.7195 30.7741 31.8949 30.509 32.0128 30.2171C32.1307 29.9253 32.1886 29.6127 32.183 29.298C32.1775 28.9833 32.1086 28.673 31.9805 28.3855C31.8524 28.098 31.6677 27.8392 31.4374 27.6246L19.8124 15.9996L31.4374 4.37464C31.8514 3.93035 32.0768 3.3427 32.0661 2.73551C32.0554 2.12832 31.8094 1.54899 31.38 1.11957C30.9506 0.690158 30.3713 0.444184 29.7641 0.433471C29.1569 0.422757 28.5692 0.648142 28.1249 1.06214L16.4999 12.6871L4.87493 1.06214Z",
                              fill: "#FF4747"
                            })
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('invoice.payment-canceled-text')), 1)
                      ]))
                    : (_ctx.currentDeal.status === _unref(DealStatus).TRANSFER_CONFIRMED)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _cache[22] || (_cache[22] = _createElementVNode("svg", {
                            class: "loader",
                            viewBox: "0 0 60 60"
                          }, [
                            _createElementVNode("circle", {
                              class: "background",
                              cx: "30",
                              cy: "30",
                              r: "27"
                            }),
                            _createElementVNode("circle", {
                              class: "progress",
                              cx: "30",
                              cy: "30",
                              r: "27"
                            })
                          ], -1)),
                          _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('invoice.confirm-waiting-text')), 1)
                        ]))
                      : (_ctx.currentDeal.status === _unref(DealStatus).COMPLETED)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "result__success" }, [
                              _createElementVNode("svg", {
                                width: "55",
                                height: "48",
                                viewBox: "0 0 55 48",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", {
                                  d: "M53.5216 7.24252L21.2139 45.7041C20.8595 46.1262 20.4186 46.4672 19.9209 46.704C19.4232 46.9408 18.8804 47.0679 18.3293 47.0767H18.2644C17.7253 47.0765 17.1923 46.9629 16.6999 46.7435C16.2075 46.524 15.7668 46.2034 15.4062 45.8026L1.56008 30.418C1.20844 30.045 0.934897 29.6055 0.755533 29.1253C0.576168 28.6452 0.494604 28.134 0.515626 27.6218C0.536649 27.1096 0.659836 26.6068 0.877951 26.143C1.09607 25.6791 1.40471 25.2635 1.78574 24.9206C2.16676 24.5777 2.61249 24.3144 3.09671 24.1463C3.58094 23.9781 4.09389 23.9084 4.60543 23.9413C5.11697 23.9742 5.61677 24.109 6.07546 24.3379C6.53415 24.5667 6.94247 24.8849 7.27643 25.2738L18.1634 37.3699L47.6322 2.29541C48.2932 1.53117 49.2284 1.05776 50.2357 0.977494C51.2429 0.897231 52.2413 1.21657 53.015 1.86648C53.7887 2.51638 54.2756 3.44466 54.3704 4.45064C54.4652 5.45663 54.1603 6.45951 53.5216 7.24252Z",
                                  fill: "#05CF2A"
                                })
                              ])
                            ], -1)),
                            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('invoice.payment-success-text')), 1)
                          ]))
                        : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (phase.value === 'pay')
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("button", {
                  type: "button",
                  class: "mt-cta",
                  onClick: _withModifiers(goToReceipt, ["prevent"])
                }, [
                  (showReceiptStep.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[24] || (_cache[24] = _createTextVNode(" Я перевёл. Отправить квитанцию ")),
                        _cache[25] || (_cache[25] = _createElementVNode("svg", {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "none"
                        }, [
                          _createElementVNode("path", {
                            d: "M5 12H19M19 12L13 6M19 12L13 18",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          })
                        ], -1))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("Я перевел ровно " + _toDisplayString(_unref(numberFormatter).formatMoney(Number(_ctx.invoice.sum.amount), _ctx.invoice.sum.currency)), 1)
                      ], 64))
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "mt-cancel",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.cancelDeal(_ctx.invoice.cancelUrl)), ["prevent"]))
                }, "Отменить платеж")
              ]))
            : _createCommentVNode("", true),
          (phase.value === 'receipt')
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("button", {
                  type: "button",
                  class: "mt-cta",
                  onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmTransfer && _ctx.confirmTransfer(...args)), ["prevent"]))
                }, "Я отправил квитанцию"),
                _createElementVNode("button", {
                  type: "button",
                  class: "mt-cancel",
                  onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.cancelDeal(_ctx.invoice.cancelUrl)), ["prevent"]))
                }, "Отменить платеж")
              ]))
            : _createCommentVNode("", true),
          (phase.value === 'verify' && _ctx.currentDeal.status !== _unref(DealStatus).TRANSFER_CONFIRMED && (_ctx.invoice.status !== _unref(InvoiceStatus).PAID && _ctx.invoice.cancelUrl || _ctx.invoice.status === _unref(InvoiceStatus).PAID && _ctx.invoice.successUrl))
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createElementVNode("a", {
                  href: _ctx.invoice.status !== _unref(InvoiceStatus).PAID ? _ctx.invoice.cancelUrl : _ctx.invoice.successUrl,
                  class: "mt-cta"
                }, "Вернуться", 8, _hoisted_40)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([{'visible': !!_unref(copyState).copyHintTimeout}, "copy-container"])
        }, _toDisplayString(_ctx.$t('invoice.tooltip.copied')) + ": " + _toDisplayString(_unref(copyState).copyValue), 3)
      ]))
    : _createCommentVNode("", true)
}
}

})